"use client";
import {
  IVerticalTabsProps,
  VerticalTabs,
} from "@/components/common/verticalTabs";
import { Section } from "@/components/layout/section";
import { ReactNode, useState } from "react";
import { BiChevronRight } from "react-icons/bi";
import { Button } from "../common/button";

interface SectionTabsItem {
  title: string;
  subtitle: string;
  icon?: React.ReactNode;
  content: React.ReactNode;
}

interface SectionTabsProps
  extends Omit<IVerticalTabsProps, "onChange" | "items" | "onChange"> {
  items: SectionTabsItem[];
  sectionTitle?: string | ReactNode;
  sectionSubtitle?: string;
  sectionClassName?: string;
  reverse?: boolean;
  buttonLabel?: string;
  href?: string;
  dark?: boolean;
}

export const SectionTabs = ({
  items,
  sectionTitle,
  sectionSubtitle,
  sectionClassName = "",
  reverse = false,
  buttonLabel = "",
  dark = false,
  href = "/contact",
  ...verticalTabsProps
}: SectionTabsProps) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <Section
      sectionClass={sectionClassName}
      className={`flex-col gap-8 ${dark ? "text-white" : "text-black"} min-h-[70vh] flex justify-center`}
    >
      <div
        className={`flex flex-col md:flex-row w-full gap-8 ${reverse ? "md:!flex-row-reverse" : ""}`}
      >
        {/* Tabs */}
        <div
          className={`flex flex-col gap-4 items-${reverse ? "end" : "start"} md:size-full`}
        >
          <div className="flex flex-col gap-4">
            {sectionTitle && <h1>{sectionTitle}</h1>}
            {sectionSubtitle && (
              <p className={dark ? "text-white" : "text-black-500"}>
                {sectionSubtitle}
              </p>
            )}
          </div>
          <div
            className={`flex flex-col gap-4 items-${reverse ? "end" : "start"} md:size-full`}
          >
            <VerticalTabs
              backgroundSelectionColor={dark ? "#333463" : "white"}
              {...verticalTabsProps}
              items={items.map(({ title, subtitle, icon }) => ({
                title,
                subtitle,
                icon,
              }))}
              onChange={(index) => setSelectedIndex(index)}
            />
          </div>
          {buttonLabel && (
            <div
              className={`flex justify-${reverse ? "start" : "end"} w-full mt-4 md:mt-0`}
            >
              <Button
                href={href}
                label={buttonLabel}
                iconRight={<BiChevronRight size={20} />}
                variant="outline-primary"
              />
            </div>
          )}
        </div>

        {/* Conteúdo dinâmico */}
        <div
          className={`flex flex-col items-center md:items-${reverse ? "start" : "end"} justify-center md:size-full`}
        >
          {items[selectedIndex]?.content}
        </div>
      </div>
    </Section>
  );
};
